import { Component, OnInit } from '@angular/core';
import { ChildDataTableDirective } from '../../../shared/directives/child-data-table.directive';
import { Item } from '../../items/models/item.model';
import { ColumnConfig } from '../../../shared/models/column-config.model';

import { AsyncValidatorFn, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TitleService } from '../../../shared/services/title.service';
import { ItemsService } from '../../items/items.service';
import { Observable, combineLatest, switchMap, EMPTY } from 'rxjs';
import { ResultSet } from '../../../shared/models/result-set.model';
import { NotificationService } from '../../../shared/services/notification.service';
import { PageStateManagerService } from '../../../shared/services/page-state-manager.service';
import { AuthService } from '../../../shared/services/auth.service';
import { PlotItem } from '../models/plot-item.model';
import { PlotItemsService } from '../plot-items.service';
import { existsValidator } from '../../../shared/validators/exists.validator';

@Component({
  selector: 'app-item-plots-list',
  standalone: false,
  templateUrl: './plot-items-list.component.html',  
})
export class PlotItemsListComponent extends ChildDataTableDirective<Item> implements OnInit {
  override columns: ColumnConfig[] = []

  override modelName: string = 'Plot Item';

  constructor(
    private itemsService: ItemsService, 
    private plotItemsService: PlotItemsService,
    fb: FormBuilder, 
    route: ActivatedRoute, 
    router: Router, 
    titleService: TitleService,
    notificationService: NotificationService,
    pageStateManager: PageStateManagerService,
    authService: AuthService,
  ) {
    super(
      itemsService, 
      fb, 
      route, 
      router, 
      titleService, 
      notificationService,
      pageStateManager,
      authService
    );       
  }
  override ngOnInit() {    
    this.setOptions()    
    this.route.paramMap.subscribe(params => {
        const parentId = params.get('plotId')!;
        this.parentID = parseInt(parentId);        
      });   
    this.columns = [
      { 
        name: 'id',
        label: 'Name',
        inputType: 'select',
        options: [],
        validators: [Validators.required],
        asyncValidators: [existsValidator(this.plotItemsService, this.parentID) as AsyncValidatorFn],
        errorMessages: { 
          required: 'You must select something',
          exists: 'This plot already contains this item' 
        },
        displayColumn: 'name'        
      }
    ];
    super.ngOnInit(); 
  }  
  
  protected override buildResultSet$(): Observable<ResultSet<Item>> {    
    return combineLatest([
          this.currentPageSubject,
          this.pageSizeSubject
        ]).pipe(          
          switchMap(([page, size]) => {
            if(!this.parentID) {
              console.error('Parent ID not set');
              return EMPTY
            }
            const offset = (page - 1) * size;            
            return this.itemsService.getItemsForPlot(this.parentID, offset, size);
          })
        );
  }

  override onGoBack() {
    this.router.navigate(['/plots']);
  }

  override onCreate(item: Item): void {
    const plotItem = {
      
      plotId: this.parentID,
      authorisedItemId: item.id
    }
    this.plotItemsService.create(plotItem as PlotItem).subscribe(() => {
      this.notificationService.success(`${this.modelName} created successfully`);
      this.currentPageSubject.next(this.currentPage)
    });
  }

  override delete(itemId: number): void {
    if(!this.parentID) {
      console.error('Parent ID not set');
      return;
    }
    this.plotItemsService.deletePlotItem(this.parentID, itemId).subscribe(() => {
      this.notificationService.success(`${this.modelName} deleted successfully`);
      this.currentPageSubject.next(this.currentPage)
    });

  }

  private async setOptions() {
    this.itemsService.getAll(0,200).subscribe(items => {
      const plotOptions = items.data.map(item => ({
        value: item.id, 
        label: item.name
      }));
  
      // Find the relevant column and set options
      const plotNumberColumn = this.columns.find(col => col.name === 'id');
      if (plotNumberColumn) {
        plotNumberColumn.options = plotOptions;
      }
    });
  }
}
  


